

import { useState } from "react"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"
import { Footer } from "../../../Footer/Footer"


export const MarineLiabilityInsurance = () => {

    const [ReadMoreText, setReadMoreText] = useState(false)

    const handleReadmore = () => {
        setReadMoreText(!ReadMoreText)
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row" onLoad={() => window.scrollTo(0, 0)}>
                    <div className="col-12">
                        <Header actives="MarineLiabilityInsurance" />
                        <HerosectionsAll ScreenName="Marine Liability Insurance" ScreenSearch="InsurableInterest" />
                        <div className="row p-2 p-lg-5" >

                            <div className="col-12 col-lg-12 py-5">
                                <div className="p-4 faint " style={{ position: 'relative', textAlign: 'justify', }}>
                                    <h5 className="fw-bold gray_color">Marine Liability Insurance</h5>
                                    <p>Most of the liabilities faced by the shipowners, such as liability towards cargo Owners due to breach of the contract of carriage, Damage to third party property, Third party death/personal injuries, Pollution liability, Wreck Removal liability is taken care by his entry into the Protection & Indemnity (P& I) Club.  </p>
                                    <p>In addition to the shipowner's liabilities, other people and businesses involved in the maritime industry run the risk of being held legally liable for Third party property damage, Third party personal injury or death, or even possibly a loss of Income. Theses areas of liability is being underwritten in the mutual as well as Non-Mutual Market. </p>
                                    <p>Insurance protection against potential legal liabilities is necessary for Marina operators, Port and Terminal Operators, Ship Repairers, Employers' liability (marine), Charterers, Bankers, and financial institutions (mortgagees). </p>

                                    {ReadMoreText && (
                                        <div>
                                            <p>
                                                Underwriters provides the insurance protection against various policies such as Charterers Legal Liability insurance, Mortgagee’s Interest Insurance (MII), Ship Repairer’s Liability Insurance. Port & Terminal Operator’s Liability Insurance. Subject to policy conditions and warranties, this insurance may cover marine as well as non-marine risks. For example  Marina Operators insurance also covers the wider Public Liability risks.
                                            </p>
                                            <p>
                                                This type of insurance covers are the specialised insurance covers and need the detail analysis of the scope of work of the assured for example to issue the Charterers Legal Liability insurance, underwriter must know the Charterer Party wordings and must know whether the assured is using the Standard Charter Form or any other wordings.
                                            </p>
                                            <p>Join the MILSO Team to get knowledge and insight into this relatively unexplored Marine Liability Market! </p>

                                        </div>

                                    )}

                                    <p className="float-end read_more_btn pb-lg-3">
                                        <button className="btn button" onClick={handleReadmore}>
                                            <span>{ReadMoreText ? 'Read Less' : 'Read More'}</span>
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    )
}



